<template>
    <div class="marketplace-service-section">
        <v-container>
            <div class="service-banner d-flex flex-column align-center justify-center">
                <h2 class="service-title mb-8">บริการตลาดชุมชน</h2>

                <v-row class="service-row justify-center" style="width: 100%">
                    <v-col cols="12" md="3" class="text-center">
                        <div class="service-item">
                            <div class="icon-circle mb-4">
                                <v-icon color="white" large>mdi-shopping</v-icon>
                            </div>
                            <p class="service-text">สินค้าชุมชนจากผู้ผลิต<br>คุณภาพน่าเชื่อถือ</p>
                        </div>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <div class="service-item">
                            <div class="icon-circle mb-4">
                                <v-icon color="white" large>mdi-package-variant-closed</v-icon>
                            </div>
                            <p class="service-text">จัดส่งสินค้าได้ 24 ชั่วโมง</p>
                        </div>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <div class="service-item">
                            <div class="icon-circle mb-4">
                                <v-icon color="white" large>mdi-map-marker-outline</v-icon>
                            </div>
                            <p class="service-text">ปักหมุดตรอบคลุมทุกพื้นที่</p>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "MarketplaceService",
};
</script>

<style scoped>
.marketplace-service-section {
    padding: 40px 0 80px;
}

.service-banner {
    background-color: #FEF3ED;
    border-radius: 12px;
    padding: 60px 20px;
    position: relative;
}

.service-title {
    font-size: 32px;
    font-weight: 700;
    color: #A65510;
}

.icon-circle {
    width: 80px;
    height: 80px;
    background-color: #F4811F;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.service-text {
    font-size: 16px;
    color: #A65510;
    font-weight: 500;
    line-height: 1.5;
}
</style>
